(function () {
    'use strict';

    angular.module('app.widgets')
        .component('hereMaps', {
            bindings: {
                location: '<',
                zoom: '<',
                center: '<',
                marker: '<',
                notFound: '<'
            },
            controller: HereMapsController,
            controllerAs: 'vm',
            templateUrl: 'app/widgets/here-maps/here.maps.component.html'
        });

    /* @ngInject */
    function HereMapsController(Hmaps, config) {
        var vm = this;
        
        vm.$onInit = onInit;
        vm.$onChanges = onChanges;
        vm.platform = null;
        vm.mapTypes = null;
        vm.map = null;

        function onInit() {
            vm.platform = new H.service.Platform({
                apikey: config.hereMaps.apiKey,
            });
            vm.mapTypes = vm.platform.createDefaultLayers();
            var listOfMaps = document.querySelectorAll('.hereMapContainer');
            var lastMap = listOfMaps[listOfMaps.length - 1];
            vm.map = new H.Map(lastMap, vm.mapTypes.vector.normal.map, {
                zoom: vm.zoom,
                center: vm.center
            });

            var ui = H.ui.UI.createDefault(vm.map, vm.mapTypes);
            var zoom = ui.getControl('zoom');
            zoom.setAlignment('top-left');
            dropMarker(vm.marker);
        }

        function onChanges(changes) {
            if (changes.marker) {
                dropMarker(changes.marker.currentValue);
            }
        }

        function dropMarker(coordinates) {
            if (vm.map && coordinates) {
                var marker = new H.map.Marker(coordinates);

                vm.map.addObject(marker);

                vm.map.setCenter(coordinates);
                vm.map.setZoom(vm.zoom);
            }
        }

    }
})();
